var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: "100%",
    viewBox: "0 0 16 15",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 3.2H3.2V0H12.8V3.2ZM12.8 7.6C13.0267 7.6 13.2167 7.52333 13.37 7.37C13.5233 7.21667 13.6 7.02667 13.6 6.8C13.6 6.57333 13.5233 6.38333 13.37 6.23C13.2167 6.07667 13.0267 6 12.8 6C12.5733 6 12.3833 6.07667 12.23 6.23C12.0767 6.38333 12 6.57333 12 6.8C12 7.02667 12.0767 7.21667 12.23 7.37C12.3833 7.52333 12.5733 7.6 12.8 7.6ZM11.2 12.8V9.6H4.8V12.8H11.2ZM12.8 14.4H3.2V11.2H0V6.4C0 5.72 0.233333 5.15 0.7 4.69C1.16667 4.23 1.73333 4 2.4 4H13.6C14.28 4 14.85 4.23 15.31 4.69C15.77 5.15 16 5.72 16 6.4V11.2H12.8V14.4Z",
    fill: "#365BCA"
  })));
};

export default __webpack_public_path__ + "static/media/print-icon.580d21f1.svg";
export { SvgComponent as ReactComponent };